<template>
    <div style="display: flex;justify-content: center; text-align: center;margin-top: 32px;
    padding-left: 12px;padding-right: 12px;">
        <a :href="`${ADMIN_SHOP_URL}${url}`"
            style="text-decoration: underline;color: rgb(220 38 38);font-weight: bold;">
            This function has been offline.
            Click to use the new version of the management backend
            <br />
            <br />
            この機能はオフラインになっています。新しいバージョンの管理バックグラウンドを使用するにはクリックしてください。
        </a>
    </div>
</template>


<script>
import ADMIN_SHOP_URL from '@/utils/admin-shop-url'

export default {
    name: 'offline-notice',
    props: ['url'],
    data() {
        return {
            ADMIN_SHOP_URL
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/offline-notice.vue